import { Route } from '@/app/router'

const Orders = () => import('./index.vue')

const OrdersMeta = {
	sort: 7,
	displayInSidebar: true,
	displayName: 'order',
	icon: 'fal shopping-cart',
	activeIcon: 'fas shopping-cart'
}

const OrdersProps = ['page', 'perPage']

export default new Route('/orders', Orders)
	.as('Dashboard:Orders')
	.meta(OrdersMeta)
	.props(OrdersProps)
	.permissions(['VIEW_ORDER'])
